module.exports = __webpack_public_path__ + "static/img/nowTime.7de49f59.png";